import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import MultiSelect from "../../components-react/MultiSelect";
import CustomizedDropzon from "../../components-react/CustomizedDropzon";
import {
  HHMMSS,
  movementTypes,
  workoutModes,
} from "../../common-data/DropdowData";
import { validateExerciseForm } from "../Datas";
import {
  fetchWorkoutCategoriesData,
  fetchWorkoutEquipmentsData,
  fetchWorkoutExerciseDropdown,
} from "../../../redux/workout-reducers/workoutApis";
import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import {
  workoutExercisesAdd,
  workoutExercisesUpdate,
} from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import AddEquipmentForm from "../equipments/AddEquipmentForm";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";

const ExerciseAddForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { equipmentsData, workoutCategoriesData, exerciseDropdownData } =
    useSelector((state) => state.workoutApi);
  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const forminitials = {
    exerciseName: isEdit && rowData?.wo_name ? rowData.wo_name : "",
    selPrimaryMuscle:
      isEdit && rowData?.category_id && rowData?.category
        ? { value: rowData.category_id, label: rowData.category }
        : "",
    selSecondaryMuscle:
      isEdit && rowData?.secondary_category
        ? rowData.secondary_category.map((workout) => ({
            label: workout.name,
            value: workout.uid,
          }))
        : [],
    selEquipmentReq:
      isEdit && rowData?.equipment_required
        ? rowData.equipment_required.map((workout) => ({
            label: workout.name,
            value: workout.uid,
          }))
        : [],
    selWorkoutMode:
      isEdit && rowData?.workout_mode
        ? {
            value: rowData.workout_mode,
            label: rowData.workout_mode?.replace(/_/g, " "),
          }
        : "",
    tentiveCalorie: isEdit && rowData?.tnv_calorie ? rowData.tnv_calorie : "",
    selAltrnateWorkouts:
      isEdit && rowData?.alternate
        ? rowData.alternate.map((workout) => ({
            label: workout.wo_name,
            value: workout.workout_id,
          }))
        : [],
    // tentativeDuration: isEdit && rowData?.e_duration ? rowData.e_duration : "",
    selTentativeDurationHH:
      isEdit && rowData?.workout_mode === "time_based" && rowData?.e_duration
        ? {
            label: `${rowData.e_duration}`.split(":")[0],
            value: `${rowData.e_duration}`.split(":")[0],
          }
        : "",
    selTentativeDurationMM:
      isEdit && rowData?.workout_mode === "time_based" && rowData?.e_duration
        ? {
            label: `${rowData.e_duration}`.split(":")[1],
            value: `${rowData.e_duration}`.split(":")[1],
          }
        : "",
    selTentativeDurationSS:
      isEdit && rowData?.workout_mode === "time_based" && rowData?.e_duration
        ? {
            label: `${rowData.e_duration}`.split(":")[2],
            value: `${rowData.e_duration}`.split(":")[2],
          }
        : "",
    tentativeReps:
      isEdit && rowData?.workout_mode === "rep_based" && rowData?.e_duration
        ? rowData.e_duration
        : "",
    selFileType:
      isEdit && rowData?.type
        ? { value: rowData.type, label: rowData.type }
        : {
            value: "upload",
            label: "Upload",
          },
    selMovementType:
      isEdit && rowData?.movement_type
        ? { value: rowData.movement_type, label: rowData.movement_type }
        : "",
    describeExercise: isEdit && rowData?.description ? rowData.description : "",
    exerciseIconLink: isEdit && rowData?.image ? rowData.image : "",
    exerciseVideoLink: isEdit && rowData?.video ? rowData.video : "",
    exerciseImgLink: isEdit && rowData?.thumbnail ? rowData.thumbnail : "",
    isActive: isEdit && rowData.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const imgVdoInitials = {
    exerciseIconImg:
      isEdit && rowData?.image ? [{ data_url: rowData.image }] : [],
    exerciseVideo: [],
    exerciseImg:
      isEdit && rowData?.thumbnail ? [{ data_url: rowData.thumbnail }] : [],
  };
  const [formImages, setFormImages] = useState(imgVdoInitials);

  const maxNumber = 1;
  const [formErrors, setFormErrors] = useState({});
  const iniValues = {
    status: "active",
    limit: 2000,
    page: 1,
    search: "",
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const initialDropdown = {
    allEquipments: [],
    allWorkoutCategories: [],
    totalPages: 1,
  };
  const [allDropdown, setAllDropdown] = useState(initialDropdown);
  const [isSubmit, setIsSubmit] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModalvalues() {
    setModValues(iniModvalues);
    getWorkoutEquipments(fetchValues);
  }

  function onClickBtn(name) {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      cardName: name,
    }));
  }

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);
    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    if (name === "selPrimaryMuscle") {
      setFormValues({ ...formValues, selAltrnateWorkouts: [], [name]: value });
    } else setFormValues({ ...formValues, [name]: value });
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);
    setFormImages((prevImages) => ({
      ...prevImages,
      [name]: imageList,
    }));
  };

  const handleVideoDrop = (acceptedFiles) => {
    setIsSubmit(false);
    setFormImages((prevImages) => ({
      ...prevImages,
      exerciseVideo: [...prevImages.exerciseVideo, ...acceptedFiles],
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateExerciseForm(formValues, formImages, isEdit));
    setIsSubmit(true);
  };

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? workoutExercisesUpdate : workoutExercisesAdd;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(forminitials);
        setFormImages(imgVdoInitials);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function getWorkoutEquipments(filters) {
    dispatch(
      fetchWorkoutEquipmentsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutCategory(filters) {
    dispatch(
      fetchWorkoutCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutExercise(filters) {
    dispatch(
      fetchWorkoutExerciseDropdown({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  // ********-------------
  const handleSearchChange = (inputValue) => {
    setFetchValues((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (fetchValues.page + 1 <= allDropdown.totalPages) {
      setFetchValues((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setFetchValues((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };
  // ------------------**********

  useEffect(() => {
    if (isEdit) {
      setFormValues((prevs) => ({
        ...prevs,
        exerciseName: isEdit && rowData?.wo_name ? rowData.wo_name : "",
        selPrimaryMuscle:
          isEdit && rowData?.category_id && rowData?.category
            ? { value: rowData.category_id, label: rowData.category }
            : "",
        selSecondaryMuscle:
          isEdit && rowData?.secondary_category
            ? rowData.secondary_category.map((workout) => ({
                label: workout.name,
                value: workout.uid,
              }))
            : [],
        selEquipmentReq:
          isEdit && rowData?.equipment_required
            ? rowData.equipment_required.map((workout) => ({
                label: workout.name,
                value: workout.uid,
              }))
            : [],
        selWorkoutMode:
          isEdit && rowData?.workout_mode
            ? {
                value: rowData.workout_mode,
                label: rowData.workout_mode?.replace(/_/g, " "),
              }
            : "",
        tentiveCalorie:
          isEdit && rowData?.tnv_calorie ? rowData.tnv_calorie : "",
        selTentativeDurationHH:
          isEdit &&
          rowData?.workout_mode === "time_based" &&
          rowData?.e_duration
            ? {
                label: `${rowData.e_duration}`.split(":")[0],
                value: `${rowData.e_duration}`.split(":")[0],
              }
            : "",
        selTentativeDurationMM:
          isEdit &&
          rowData?.workout_mode === "time_based" &&
          rowData?.e_duration
            ? {
                label: `${rowData.e_duration}`.split(":")[1],
                value: `${rowData.e_duration}`.split(":")[1],
              }
            : "",
        selTentativeDurationSS:
          isEdit &&
          rowData?.workout_mode === "time_based" &&
          rowData?.e_duration
            ? {
                label: `${rowData.e_duration}`.split(":")[2],
                value: `${rowData.e_duration}`.split(":")[2],
              }
            : "",
        tentativeReps:
          isEdit && rowData?.workout_mode === "rep_based" && rowData?.e_duration
            ? rowData.e_duration
            : "",
        selAltrnateWorkouts:
          isEdit && rowData?.alternate
            ? rowData.alternate.map((workout) => ({
                label: workout.wo_name,
                value: workout.workout_id,
              }))
            : [],
        // tentativeDuration:
        //   isEdit && rowData?.e_duration ? rowData.e_duration : "",
        selFileType:
          isEdit && rowData?.type
            ? { value: rowData.type, label: rowData.type }
            : {
                value: "upload",
                label: "Upload",
              },
        selMovementType:
          isEdit && rowData?.movement_type
            ? { value: rowData.movement_type, label: rowData.movement_type }
            : "",
        describeExercise:
          isEdit && rowData?.description ? rowData.description : "",
        exerciseIconLink: isEdit && rowData?.image ? rowData.image : "",
        exerciseVideoLink: isEdit && rowData?.video ? rowData.video : "",
        exerciseImgLink: isEdit && rowData?.thumbnail ? rowData.thumbnail : "",
        isActive: isEdit && rowData.status === "active" ? true : false,
      }));

      setFormImages((prevs) => ({
        ...prevs,
        exerciseIconImg:
          isEdit && rowData?.image ? [{ data_url: rowData.image }] : [],
        exerciseVideo: [],
        exerciseImg:
          isEdit && rowData?.thumbnail ? [{ data_url: rowData.thumbnail }] : [],
      }));
    }
  }, []);

  useEffect(() => {
    getWorkoutEquipments(fetchValues);
    getWorkoutCategory(fetchValues);
    // getWorkoutExercise(fetchValues);
  }, [fetchValues]);

  useEffect(() => {
    if (formValues.selPrimaryMuscle?.value) {
      fetchValues.category_id = formValues.selPrimaryMuscle.value;
    } else {
      fetchValues.category_id = "";
    }

    getWorkoutExercise(fetchValues);
  }, [formValues.selPrimaryMuscle, fetchValues]);

  useEffect(() => {
    if (equipmentsData?.dropdown?.length > 0) {
      setAllDropdown((prevs) => ({
        ...prevs,
        allEquipments: equipmentsData?.dropdown,
        totalPages: equipmentsData?.pagination?.[0]?.pagination || 1,
      }));
    } else if (workoutCategoriesData?.dropdown?.length > 0) {
      setAllDropdown((prevs) => ({
        ...prevs,
        allWorkoutCategories: workoutCategoriesData?.dropdown,
        totalPages: workoutCategoriesData?.pagination?.[0]?.pagination || 1,
      }));
    } else {
      setAllDropdown(initialDropdown);
    }
  }, [equipmentsData, workoutCategoriesData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const secondaryMuscleValues = formValues.selSecondaryMuscle
        .map((item) => item.value)
        .join(",");
      const equipmentsValues = formValues.selEquipmentReq
        .map((item) => item.value)
        .join(",");
      const alternateExerciseUIDs = formValues.selAltrnateWorkouts
        .map((item) => item.value)
        .join(",");

      const userData = {
        wo_name: formValues.exerciseName || "",
        category: formValues.selPrimaryMuscle?.value || "",
        secondary_category: secondaryMuscleValues || "",
        workout_mode: formValues.selWorkoutMode?.value || "",
        equipment_required: equipmentsValues || "",
        tnv_calories: formValues.tentiveCalorie || "",
        alternate_workout: alternateExerciseUIDs || "",
        e_duration:
          formValues.selWorkoutMode?.value === "rep_based"
            ? formValues.tentativeReps || ""
            : `${formValues.selTentativeDurationHH?.value || "00"}:${
                formValues.selTentativeDurationMM?.value || "00"
              }:${formValues.selTentativeDurationSS?.value || "00"}`,
        type: formValues.selFileType?.value || "upload",
        movement_type: formValues.selMovementType?.value || "",
        description: formValues.describeExercise || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (formValues.selFileType?.value === "link") {
        formData.append(`image`, formValues.exerciseIconLink || "");
        formData.append(`video`, formValues.exerciseVideoLink || "");
        formData.append(`thumbnail`, formValues.exerciseImgLink || "");
      } else {
        formImages.exerciseIconImg?.forEach((img) => {
          formData.append(
            `image`,
            img.file ? img.file : rowData?.image ? "" : ""
          );
        });

        formImages.exerciseVideo?.forEach((vid) => {
          formData.append(`video`, vid ? vid : rowData?.video ? "" : "");
        });

        formImages.exerciseImg?.forEach((img) => {
          formData.append(
            `thumbnail`,
            img.file ? img.file : rowData?.thumbnail ? "" : ""
          );
        });
      }

      if (isEdit) {
        formData.append("uid", rowData.uid);
      }

      const handleConfirm = async () => {
        handleAdd(formData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!
        `,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Exercise`
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Add Exercise Modal"
        ariaHideApp={false}>
        {modValues.cardName === "add-equipment" ? (
          <AddEquipmentForm
            userInfoData={userInfoData}
            callFunction={callFunction}
            closeModal={onCloseModalvalues}
          />
        ) : null}
      </Modal>

      <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
        <CommonHeadingNBtns
          title={`${isEdit ? "Update" : "Add"} Exercise`}
          onClose={closeModal}
          onClick={onSubmit}
          isLoading={postPutLoadingFormData}
        />
        <form className="formContainer">
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="exerciseName" className={`formInputLabel `}>
                Exercise Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Exercise name"
                className={`formInput ${
                  formErrors?.exerciseName ? "formError" : ""
                }`}
                name="exerciseName"
                value={formValues.exerciseName}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="selMovementType" className="formInputLabel">
                Movement type <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selMovementType && "formError"
                }`}>
                <SelectDropdown
                  options={movementTypes}
                  selectedOption={formValues.selMovementType}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selMovementType")
                  }
                  name="from the list"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selPrimaryMuscle" className="formInputLabel">
                Primary muscle/Category <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selPrimaryMuscle && "formError"
                }`}>
                <SelectDropdownDynamic
                  // options={allDropdown.allEquipments}
                  options={workoutCategoriesData?.dropdown || []}
                  selectedOption={formValues.selPrimaryMuscle}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selPrimaryMuscle")
                  }
                  name="from the list"
                  preventKeyboardOpen={false}
                  onSearchChange={handleSearchChange}
                  fetchMoreData={fetchMoreData}
                  fetchPreviousData={fetchPreviousData}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selSecondaryMuscle" className="formInputLabel">
                Secondary muscle/Category{" "}
                {formValues.selMovementType?.value === "compound" ? (
                  <span className="required">*</span>
                ) : null}
              </label>

              <div
                className={`commonWrapper no-border multi-select ${
                  formErrors.selSecondaryMuscle ? "error" : ""
                }`}>
                <MultiSelect
                  options={workoutCategoriesData?.dropdown || []}
                  state={formValues.selSecondaryMuscle}
                  setState={(selectedValue) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      selSecondaryMuscle: selectedValue,
                    }))
                  }
                  name="select multiple from the list"
                  preventKeyboardOpen={false}
                  onSearchChange={handleSearchChange}
                  fetchMoreData={fetchMoreData}
                  fetchPreviousData={fetchPreviousData}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selWorkoutMode" className="formInputLabel">
                Workout Mode <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selWorkoutMode && "formError"
                }`}>
                <SelectDropdown
                  options={workoutModes}
                  selectedOption={formValues.selWorkoutMode}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selWorkoutMode")
                  }
                  name="from the list"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>

            <div className="formInputBox">
              <label
                htmlFor="tentiveCalorie"
                className={`formInputLabel ${
                  formErrors?.tentiveCalorie && "formError"
                }`}>
                Tentative Calorie <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Tentative Calorie"
                className={`formInput ${
                  formErrors?.tentiveCalorie ? "formError" : ""
                }`}
                name="tentiveCalorie"
                value={formValues.tentiveCalorie}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div
              className={`formInputBox ${
                formValues.selWorkoutMode?.value === "rep_based" ? "" : "span2"
              }`}>
              <label
                htmlFor={`selTentativeDurationSS`}
                className="formInputLabel">
                Tentative duration <span className="required">*</span>
              </label>

              {formValues.selWorkoutMode?.value === "rep_based" ? (
                <div
                  className={`multi-input-odd ${
                    formErrors?.tentativeReps ? "error" : ""
                  }`}>
                  <input
                    type="text"
                    placeholder="Enter duration"
                    className={`formInput`}
                    name={`tentativeReps`}
                    value={formValues.tentativeReps}
                    onChange={onChangeInput}
                    min={0}
                  />

                  <div className="grayInputLine"></div>
                  <span className="value">Reps</span>
                </div>
              ) : (
                <div className="three-input-container">
                  <div
                    className={`commonWrapper ${
                      formErrors?.selTentativeDurationHH ? "formError" : ""
                    }`}>
                    <div className="first-child">
                      <SelectDropdownLabel
                        options={HHMMSS}
                        selectedOption={formValues.selTentativeDurationHH}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(
                            selectedValue,
                            "selTentativeDurationHH"
                          )
                        }
                        name="Hour"
                        preventKeyboardOpen={true}
                      />
                    </div>

                    <div className="grayInputLine"></div>
                    <span className="value">HH</span>
                  </div>
                  <div
                    className={`commonWrapper ${
                      formErrors?.selTentativeDurationMM ? "formError" : ""
                    }`}>
                    <div className="first-child">
                      <SelectDropdownLabel
                        options={HHMMSS}
                        selectedOption={formValues.selTentativeDurationMM}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(
                            selectedValue,
                            "selTentativeDurationMM"
                          )
                        }
                        name="Minutes"
                        preventKeyboardOpen={true}
                      />
                    </div>

                    <div className="grayInputLine"></div>
                    <span className="value">MM</span>
                  </div>
                  <div
                    className={`commonWrapper ${
                      formErrors?.selTentativeDurationSS ? "formError" : ""
                    }`}>
                    <div className="first-child">
                      <SelectDropdownLabel
                        options={HHMMSS}
                        selectedOption={formValues.selTentativeDurationSS}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(
                            selectedValue,
                            "selTentativeDurationSS"
                          )
                        }
                        name="Seconds"
                        preventKeyboardOpen={true}
                      />
                    </div>

                    <div className="grayInputLine"></div>
                    <span className="value">SS</span>
                  </div>
                </div>
              )}
            </div>

            <div className="formInputBox span2">
              <label
                htmlFor="selEquipmentReq"
                className={`formInputLabel ${
                  formErrors?.selEquipmentReq && "formError"
                }`}>
                Equipment required
              </label>

              <div className="input-add-btn flexBetween">
                <div
                  className={`commonWrapper no-border multi-select ${
                    formErrors.selEquipmentReq ? "error" : ""
                  }`}>
                  <MultiSelect
                    options={equipmentsData?.dropdown || []}
                    state={formValues.selEquipmentReq}
                    setState={(selectedValue) =>
                      setFormValues((prevs) => ({
                        ...prevs,
                        selEquipmentReq: selectedValue,
                      }))
                    }
                    name="select multiple from the list"
                    preventKeyboardOpen={false}
                    onSearchChange={handleSearchChange}
                    fetchMoreData={fetchMoreData}
                    fetchPreviousData={fetchPreviousData}
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-dark extraBtn"
                  style={{
                    minWidth: "150px",
                    height: "60px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => onClickBtn("add-equipment")}>
                  Add New
                </button>
              </div>
            </div>

            <div className="formInputBox">
              <label
                htmlFor="selAltrnateWorkouts"
                className={`formInputLabel ${
                  formErrors?.selAltrnateWorkouts && "formError"
                }`}>
                alternate Workouts <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper no-border multi-select ${
                  formErrors.selAltrnateWorkouts ? "error" : ""
                }`}>
                <MultiSelect
                  options={exerciseDropdownData?.dropdown || []}
                  state={formValues.selAltrnateWorkouts}
                  setState={(selectedValue) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      selAltrnateWorkouts: selectedValue,
                    }))
                  }
                  name="select multiple from the list"
                  preventKeyboardOpen={false}
                />
              </div>
            </div>

            <div className="formInputBox span4">
              <label htmlFor="describeExercise" className="formInputLabel">
                Describe exercise <span className="required">*</span>
              </label>

              <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
                <ReactQuill
                  id="describeExercise"
                  name="describeExercise"
                  className={`formInput ${
                    formErrors?.describeExercise ? "formError" : ""
                  }`}
                  placeholder="Enter how to Perform.."
                  value={formValues.describeExercise}
                  onChange={(content) =>
                    onChangeTextInput(content, "describeExercise")
                  }
                />
              </div>
            </div>
          </div>

          <div
            className={`formInputsGrid uploadsInputGrids`}
            style={{
              minHeight: formValues.selFileType?.value === "link" ? "auto" : "",
            }}>
            <div className="formInputBox formInputUploadBox">
              <label htmlFor="exerciseIconImg" className="formInputLabel">
                Exercise Icon
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  formErrors?.exerciseIconImg && "error"
                }`}
                style={{ height: "auto" }}>
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none">
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={formImages.exerciseIconImg}
                      onChange={(imageList, addUpdateIndex) =>
                        onChangeImages(imageList, "exerciseIconImg")
                      }
                      maxNumber={maxNumber}
                      dataURLKey="data_url">
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {formImages.exerciseIconImg?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}>
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16">
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onImageRemove(index)}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>

            <div className="formInputBox formInputUploadBox">
              <label htmlFor="exerciseVideo" className="formInputLabel">
                Exercise video
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  formErrors?.exerciseVideo ? "error" : ""
                }`}>
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none">
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image video">
                    <CustomizedDropzon
                      message={"Drag & drop video files here"}
                      onDrop={handleVideoDrop}
                      clearVideo={() =>
                        setFormImages((prevImages) => ({
                          ...prevImages,
                          exerciseVideo: [],
                        }))
                      }
                    />
                  </div>
                  {isEdit &&
                  rowData?.video &&
                  formImages.exerciseVideo?.length === 0 ? (
                    <span className="previous-link with-video">
                      <video width="200" height="180" controls>
                        <source src={rowData.video}></source>
                      </video>
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="formInputBox formInputUploadBox">
              <label htmlFor="exerciseImg" className="formInputLabel">
                Exercise image
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  formErrors?.exerciseImg ? "error" : ""
                }`}
                style={{ height: "auto" }}>
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none">
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={formImages.exerciseImg}
                      onChange={(imageList, addUpdateIndex) =>
                        onChangeImages(imageList, "exerciseImg")
                      }
                      maxNumber={maxNumber}
                      dataURLKey="data_url">
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {formImages.exerciseImg?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}>
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16">
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onImageRemove(index)}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  formErrors?.isActive ? "formError" : ""
                }`}>
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={`${formValues.isActive ? "Active" : "Not Active"}`}
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ExerciseAddForm;
